import { getEventPosterUrl } from "components/atoms/Image/EventPoster";
import OrderCard from "./OrderCard"
import { useLang } from "hooks/useLang"
import ordersNotFound from "lottiefiles/no_orders_found.json"
import dynamic from "next/dynamic";

const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

interface IProps {
    orders: any
    isSuccess: boolean
}

const OrderTab = ({ orders, isSuccess }: IProps) => {
    const { t } = useLang()

 

    if (isSuccess && orders.length === 0) {
        return (
            <div className="mx-auto flex w-full max-w-6xl flex-col items-center gap-5 p-5">
                <Lottie
                    animationData={ordersNotFound}
                    loop={false}
                    className="h-[180px] w-[180px] md:h-[230px] md:w-[230px]"
                />
                <h1 className="text-center text-lg font-medium capitalize md:text-3xl">
                    {t("no_orders")}
                </h1>
            </div>
        )
    }

    return (
        <div className="grid grid-cols-1 gap-5 2md:grid-cols-2">
            {orders.map((transaction: any, index: number) => {
                const poster = getEventPosterUrl(transaction.event, "mobile")
                return (
                    <OrderCard
                        key={index}
                        uniqueId={index}
                        PDF={transaction.PDF}
                        id={transaction._id}
                        numberOfTickets={
                            transaction.items.flatMap(
                                ({ tickets }: any) => tickets
                            ).length
                        }
                        status={transaction.status}
                        title={transaction.event.title}
                        poster={poster}
                        Price={transaction.Price}
                        cart={transaction.Cart}
                        cartId={transaction._id}
                        location={transaction.city}
                        startTime={transaction.event.event_date.starting_date}
                        endTime={transaction.event.event_date.ending_date}
                    />
                )
            })}
        </div>
    )
}

export default OrderTab
